/**
 * HeaderNavItem.tsx — navigasjonslenke i header
 *
 * Ren React-komponent som erstatter cds-header-nav-item.
 * Bruker next/link for ruting. Active-state markerer gjeldende rute.
 *
 * Props:
 * - href: rute-lenke
 * - active: om lenken er aktiv (markerer gjeldende side)
 * - children: lenketekst
 */

import Link from 'next/link';
import styles from './header-nav-item.module.css';

interface HeaderNavItemProps {
  href: string;
  active?: boolean;
  children: React.ReactNode;
}

export default function HeaderNavItem({ href, active = false, children }: HeaderNavItemProps) {
  return (
    <li className={styles.item}>
      <Link
        href={href}
        className={active ? styles.linkActive : styles.link}
        aria-current={active ? 'page' : undefined}
      >
        {children}
      </Link>
    </li>
  );
}
